export const calculateWorkingDays = (selectedMeses, selectedAnios, allMonthNames) => {
    // Si no hay selección, asumimos año actual y mes actual (o todos, según lógica de negocio, pero mejor ser defensivos)
    const years = selectedAnios && selectedAnios.length > 0 ? selectedAnios.map(Number) : [new Date().getFullYear()];
    const monthsIndices = selectedMeses && selectedMeses.length > 0 
        ? selectedMeses.map(m => allMonthNames.indexOf(m)) 
        : []; // Si no hay mes seleccionado, el cálculo podría ser ambiguo, retornamos 0 por seguridad o todos.

    // Días feriados fijos (Venezuela - Ejemplo básico, se puede expandir)
    const HOLIDAYS = [
        "01-01", "05-01", "06-24", "07-05", "07-24", "10-12", "12-24", "12-25", "12-31"
    ];

    let total = 0;
    let elapsed = 0;
    const now = new Date();
    // Normalizamos "hoy" al inicio del día para comparaciones justas
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    years.forEach(year => {
        monthsIndices.forEach(monthIdx => {
            const daysInMonth = new Date(year, monthIdx + 1, 0).getDate();
            for(let d = 1; d <= daysInMonth; d++) {
                const current = new Date(year, monthIdx, d);
                const dayOfWeek = current.getDay();
                const dateStr = `${String(monthIdx + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;

                // Excluir Sábados (6) y Domingos (0) y Feriados
                if (dayOfWeek !== 0 && dayOfWeek !== 6 && !HOLIDAYS.includes(dateStr)) {
                    total++;
                    if (current < today || (current.getTime() === today.getTime())) {
                        elapsed++;
                    }
                }
            }
        });
    });

    // Aseguramos que elapsed no supere total (por si acaso fechas raras)
    const finalElapsed = Math.min(elapsed, total);
    
    return {
        total,
        elapsed: finalElapsed,
        percentage: total > 0 ? ((finalElapsed / total) * 100).toFixed(1) : "0.0"
    };
};